export const INTEGRATION_TYPES = [
  {
    title: 'Hubspot',
    icon: '/images/integrations/hubspot.png',
    logo: '/images/integrations/hubspot_logo.png',
    route: 'hubspot',
    category: 'CRM',
    type: 'hubspot',
    description: 'Integrate Hubspot CRM to sync events across contacts',
    forms: true
  },
  {
    title: 'Pardot',
    route: 'pardot',
    category: 'CRM',
    type: 'pardot',
    icon: '/images/integrations/pardot.png',
    logo: '/images/integrations/pardot.png',
    description: 'Integrate with Pardot to sync events across contacts',
    forms: true
  },
  {
    title: 'Marketo',
    icon: '/images/integrations/marketo.png',
    category: 'MARKETING_ATTRIBUTION',
    logo: '/images/integrations/marketo_logo.png',
    route: 'marketo',
    type: 'marketo',
    description: 'Integrate with Marketo to sync events across contacts',
    forms: true
  },
  {
    title: 'Salesforce',
    icon: '/images/integrations/salesforce.png',
    category: 'CRM',
    logo: '/images/integrations/salesforce.png',
    route: 'salesforce',
    type: 'salesforce',
    description: 'Integrate with Salesforce to sync events across contacts',
    forms: false
  },
  {
    title: 'Zoho',
    icon: '/images/integrations/zoho.png',
    category: 'CRM',
    logo: '/images/integrations/zoho.png',
    route: 'zoho',
    type: 'zoho',
    description: 'Integrate with Zoho to sync events across contacts',
    forms: false
  },
  {
    title: 'Figma',
    icon: '/images/integrations/figma.png',
    category: 'CRM',
    logo: '/images/integrations/figma.png',
    route: 'figma',
    type: 'figma',
    description: 'Integrate with Figma to import Figma files as Storyboards',
    forms: false
  }
]